export function handleFormData(data, isencode = false) {
  const formData = new FormData()

  for (const key in data) {
    if (typeof data[key] === 'object' && data[key] !== null) {
      const v = isencode ? encodeURI(JSON.stringify(data[key])) : JSON.stringify(data[key])
      formData.append(key, v)
    } else if (data[key] === null) {
      formData.append(key, '')
    } else {
      const v = isencode ? encodeURI(data[key]) : data[key]
      formData.append(key, v)
    }
  }

  return formData
}
/**
 * 按照五粮液内部时间来定制年份
**/
export function formatWlyYear() {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  return currentMonth - 0 < 11 ? currentYear : currentYear - 0 + 1
}


// WEBPACK FOOTER //
// ./src/utils/handleFormData.js